import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { tabbedContentDriverFactory } from './TabbedContent.driver';
import { TabbedContent, TabbedContentProps } from '.';
import userEvent from '@testing-library/user-event';

describe('TabbedContent', () => {
  const render = createRendererWithUniDriver(tabbedContentDriverFactory);
  const items = [
    { id: '0', title: 'item 1' },
    { id: '1', title: 'item 2' },
    { id: '2', title: 'item 3' },
    { id: '3', title: 'item 4' },
  ];
  const bootstrap = (props: Partial<TabbedContentProps> = {}) =>
    render(
      <TabbedContent items={items} activeTabIndex={0} {...props}>
        {(id) => <div>This is tab {id}</div>}
      </TabbedContent>,
    );

  it('should render tablist with correct items and content', async () => {
    const { driver } = bootstrap();
    const expectedTitles = items.map((item) => item.title);

    const receivedTitles = await Promise.all(
      Array(items.length)
        .fill(0)
        .map((_, index) => driver.getTitleAt(index)),
    );

    expect(receivedTitles).toEqual(expectedTitles);
    expect(await driver.getActiveContent()).toContain('This is tab 0');
  });

  it('should render different content when changing active tab', async () => {
    const { driver } = bootstrap({ activeTabIndex: 1 });
    expect(await driver.getActiveContent()).toContain('This is tab 1');
  });

  it('should render all content for each tab', async () => {
    const { driver } = bootstrap();
    const allTabContent = items.map((i) => `This is tab ${i.id}`);
    const content = await Promise.all(
      Array(items.length)
        .fill(0)
        .map((_, index) => driver.getTabContent(index)),
    );

    expect(content).toEqual(allTabContent);
  });

  it('should focus the inner content when tabbing', async () => {
    const user = userEvent.setup();
    render(
      <TabbedContent items={items} activeTabIndex={0}>
        {(idx) => <button id={`button-${idx}`}>Button inside tab {idx}</button>}
      </TabbedContent>,
    );

    await user.tab(); // focus first tab
    await user.tab(); // focus inner content

    expect(document.activeElement.id).toBe('button-0');
  });
});
